import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["link"];

  connect() {
    this.hideAllContent();
  }

  switchTab(event) {
    event.preventDefault();
    this.linkTargets.forEach((link) => {
      link.classList.remove("is-active");
    });
    const activeLink = event.currentTarget;
    activeLink.classList.add("is-active");
    this.hideAllContent();
  }

  hideAllContent() {
    this.linkTargets.forEach((link) => {
      const contentId = link.dataset.querySelector;
      const content = document.querySelector(contentId);
      const isActive = link.classList.contains("is-active");
      if (content && !isActive) {
        content.classList.add("u-hidden");
      } else if (content && isActive) {
        content.classList.remove("u-hidden");
      }
    });
  }
}
